import { render, staticRenderFns } from "./CoordonateStickersFormComponent.vue?vue&type=template&id=51647af6&"
import script from "./CoordonateStickersFormComponent.vue?vue&type=script&lang=js&"
export * from "./CoordonateStickersFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoordonateStickersFormComponent.vue?vue&type=style&index=0&id=51647af6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports